<template>
  <section class="hero">
    <div class="hero__content container">
      <div class="hero__content--info">
        <div class="hero__bubble">
          <p v-if="showText">
            {{ animatedTextBeforeBold }}
            <b v-if="animatedBoldText">{{ animatedBoldText }}</b>
            {{ animatedTextAfterBold }}
          </p>
        </div>
        <p class="hero__description">
          Create personalized campaigns that resonate with your audience,
          increasing the effectiveness of your marketing efforts.
        </p>
        <div class="hero__btn btn">
          <a href="#plans">
            <button class="button">View Plans</button>
          </a>
        </div>
      </div>
      <div class="hero__content--img">
        <img :src="imageUrl" alt="Phone SMS Image">
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import mobileImageUrl from '@/assets/hero/mobile-phone.png';
import desktopImageUrl from '@/assets/hero/phone.png';

export default {
  setup() {
    const textBeforeBold = 'Optimize your outreach strategy with ';
    const boldText = 'SMS Marketing.';
    const textAfterBold = '';
    const animatedTextBeforeBold = ref('');
    const animatedBoldText = ref('');
    const animatedTextAfterBold = ref('');
    const showText = ref(false);
    const imageUrl = ref('');

    const updateImageUrl = () => {
      imageUrl.value = window.innerWidth <= 992 ? mobileImageUrl : desktopImageUrl;
    };

    const animateText = () => {
      let i = 0;
      let j = 0;
      showText.value = true;
      const typingInterval = setInterval(() => {
        if (i < textBeforeBold.length) {
          animatedTextBeforeBold.value += textBeforeBold[i];
          i++;
        } else if (j < boldText.length) {
          animatedBoldText.value += boldText[j];
          j++;
        } else if (j >= boldText.length && i >= textBeforeBold.length) {
          animatedTextAfterBold.value += textAfterBold;
          clearInterval(typingInterval);
        }
      }, 50);
    };

    onMounted(() => {
      animateText();
      updateImageUrl();
      window.addEventListener('resize', updateImageUrl);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateImageUrl);
    });

    return {
      animatedTextBeforeBold,
      animatedBoldText,
      animatedTextAfterBold,
      showText,
      imageUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/components/hero.scss";
</style>
